/** @jsxImportSource @emotion/react */

import {Switch, Route, useLocation, Redirect} from "react-router-dom";
import LoginPage from "pages/Login";
import LoadingScreen from "components/LoadingScreen";
import GlobalCss from "../GlobalCss";
import PageRoute from "./PageRoute";
import pagesConfig from "routes";
import {useAuth} from "hooks/auth";
import {AppBoundary} from "./AppBoundary";
import SelectAgency from "pages/SelectAgency";
import ErrorScreen from "components/ErrorScreen";
import {H1} from "components/elements";
import {Toaster} from "react-hot-toast";
import {Helmet} from "react-helmet";

function App() {
  const {isLoggedIn, authSessionLoading} = useAuth();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const returnUrl = searchParams.get("returnUrl");
  const redirectUrl = searchParams.get("redirectUrl");
  const currentUrl = encodeURIComponent(
    `${location.pathname}${location.hash}${location.search}`
  );

  if (isLoggedIn && redirectUrl) {
    const redirect = decodeURIComponent(redirectUrl);
    if (redirect.startsWith("http")) {
      window.location.href = redirect;
    } else {
      window.location.href = `${window.location.origin}${redirect}`;
    }
  }

  return (
    <>
      <GoogleApiScriptTag />
      <Toaster />
      <GlobalCss />
      {authSessionLoading ? (
        <LoadingScreen />
      ) : (
        <AppBoundary currentUrl={currentUrl}>
          <Switch>
            {!isLoggedIn && (
              <Route path="/login" exact>
                <LoginPage />
              </Route>
            )}
            {isLoggedIn && (
              <Route path="/selectAgency" exact>
                <SelectAgency />
              </Route>
            )}
            {returnUrl && (
              <Route>
                <Redirect to={returnUrl} />
              </Route>
            )}
            {pagesConfig.map((page) => (
              <Route
                key={page.path}
                path={page.path}
                exact={page.exact !== undefined ? page.exact : true}
              >
                <PageRoute
                  page={page}
                  searchParams={searchParams}
                  isLoggedIn={isLoggedIn}
                  currentUrl={currentUrl}
                />
              </Route>
            ))}
            <Route>
              <ErrorScreen>
                <H1>404 - Page not found</H1>
              </ErrorScreen>
            </Route>
          </Switch>
        </AppBoundary>
      )}
    </>
  );
}

function GoogleApiScriptTag() {
  const {authSession} = useAuth();
  if (!authSession?.google_api_key) {
    return <></>;
  }
  return (
    <Helmet>
      <script
        id="google-maps-script"
        src={`https://maps.googleapis.com/maps/api/js?key=${authSession?.google_api_key}&libraries=places`}
        async
        defer
      />
    </Helmet>
  );
}
export default App;
